import {CommonModule} from '@angular/common';
import {Component, OnDestroy, OnInit} from '@angular/core';
import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {
  faCamera,
  faCircleCheck,
  faCircleXmark,
  faPen,
  faSquarePlus,
  faSquareXmark
} from '@fortawesome/free-solid-svg-icons';
import {ApiService} from '../services/api.service';
import {ToastrService} from 'ngx-toastr';
import {AuthService} from '../services/auth.service';
import {FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {getUpdatedFieldsJsonReq, validateAllFormFields} from '../../common/utils';
import {Subject, takeUntil} from 'rxjs';
// interface Profiledetail {
//   imageUrl: string;
//   username: string;
//   email: string;
//   first_name: string;
//   last_name: string;
  
// }

@Component({
    selector: 'app-profile',
    imports: [CommonModule, FontAwesomeModule, ReactiveFormsModule, FormsModule],
    templateUrl: './profile.component.html',
    styleUrl: './profile.component.css'
})
export class ProfileComponent implements OnInit, OnDestroy{
  // profile = {
  //   imageUrl: 'vehicle-images/1719318833073_fullimage_1852_KA01AB1852_161.jpg', // Replace with the path to your profile image
  //   username: 'johndoe',
  //   email: 'johndoe@example.com',
  //   profileName: 'John Doe',
  //   role: 'Admin'
  // };
  // profile: any  = {
  //   imageUrl: '',
  //   username: '',
  //   email: '',
  //   first_name: '',
  //   last_name: '',
  //   mobile_number: ''
  // };
  // user:any = {};


  // // profile: {} = {};
  // constructor(private router: Router,
  //             private apiService: ApiService,
  //             private toastr: ToastrService,
  //             private authService:AuthService,
  //             library: FaIconLibrary,

  //           ){
  //   library.addIcons(faPen, faSquarePlus);
  //   // debugger;
  //   let user = authService.getUserInfo();
  //   if(user){
  //     this.user = JSON.parse(user);

  //   }
  //   this.getProfile();
    
  // }
  // ngOnInit(): void { }

  // getProfile(){
  //   this.apiService.getProfiledetail(this.user.id).subscribe({
  //     next: (res: any) => {
  //       console.log(res)
  //         this.profile = res
  //          this.profile.imageUrl = res.profile_pic ? res.profile_pic : 'noimage.png'
  //         // this.toastr.error("");

  //     },
  //     error: (err) => {
  //       console.log(err['error'])
  //       if (err['error']['non_field_errors']) {
  //         err['error']['non_field_errors'].forEach((element:any) => {
  //           this.toastr.error(element);
  //         });
  //       }
  //     }
  //   })
  // }

  // editProfile() {
  //   this.router.navigate([`/profile/edit/${this.user.id}`]);
  // }



  // edit profile
  // profile!: any;
  profile: any  = {
    imageUrl: '',
    username: '',
    email: '',
    first_name: '',
    last_name: '',
    mobile_number: '',
  };
  user:any = {};
  profileForm!: FormGroup;
  pk: any;
  role: object = {}
  organization: object = {}
  isAdmin:Boolean = false;
  isSuperUserViewer = false;
  isAdminViewer = false;
  isOwnProfile = false;
  canEditProfile = false;
  canEditRole = false;
  selectedFile: File | null = null;
  formChanged: boolean = false;
  mobileChanged: boolean = false;
  showConfirmationDialog: boolean = false;
  pId: number = 0;
  isMobileVerified!: boolean;
  isLockedRoleProfile = false;




  otpForm: FormGroup;
  error: string = '';
  success: string = '';
  isSubmitting = false;
  mobileNumber: string = ''; 
  timer: number = 100;
  private intervalId: any;

  fieldMapping: any = {
    firstName: 'first_name',
    lastName: 'last_name',
    mobileNumber: 'mobile_number',
    role: 'groups',
  }
  curUser: any = { };
  userId!: number;
  private readonly destroy$ = new Subject<void>();



  constructor(private router: Router,
              library: FaIconLibrary,
              private apiService:ApiService,
              private toastr: ToastrService,
              private authService: AuthService,
              private fb: FormBuilder,
              private route: ActivatedRoute
            ){
    library.addIcons(faSquareXmark, faSquarePlus, faPen, faCamera, faCamera, faCircleCheck, faCircleXmark)
    this.curUser = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')!) : {};
    this.isMobileVerified = this.curUser.is_mobile_verified;

    this.otpForm = this.fb.group({
      otp: ['', [Validators.required, Validators.pattern(/^\d{6}$/)]],
      mobile_number: ['', [Validators.required, Validators.pattern(/^\d{10}$/)]],
    });
 
  }
  ngOnInit(): void {
      let userObj = this.authService.getCurrentUserInfo();
      this.userId = userObj.id
      const currentRoles = Array.isArray(userObj.role) ? userObj.role : [userObj.role].filter(Boolean);
      this.isSuperUserViewer = userObj.is_superuser === true;
      this.isAdminViewer = currentRoles.includes('Admin');
      this.organizations();

    // Get pk id from url
      this.pk = this.route.snapshot.paramMap.get('pk');
      if (!this.pk) {
        this.pk = userObj.id;
      }
      this.isOwnProfile = Number(this.pk) === Number(this.userId);
      if (this.pk){
        this.getProfile(this.pk);
      }
    this.profileForm = this.fb.group({
      userName: ['', Validators.required],
      role: ['', Validators.required],
      firstName: ['', Validators.required],
      lastName: [''],
      email: ['', Validators.required],
      mobileNumber: ['', Validators.required],
      imageUrl: [''],
      organization: ['', Validators.required],
    });
      this.isAdmin = this.isSuperUserViewer || this.isAdminViewer;

    // this.sendOTP();
    // this.startCountdown();

  }

  groups(){
    this.apiService.getGroups().pipe(takeUntil(this.destroy$)).subscribe({
      next: (response: any) => {
        this.role = response
        
      },
      error: (err) =>{
        if (err['error']['detail']) {
          err['error']['detail'].forEach((element:any) => {
            this.toastr.error(element, 'Error');
          });
        }else if (err['status'] !== 403 && err.status !== 0) {
            this.toastr.error('Error while getting role.', 'Error');
          }
      }
    });
  }
  organizations(){
    this.apiService.organization().pipe(takeUntil(this.destroy$)).subscribe({
      next: (response: any) => {
        this.organization = response
      },
      error: (err) =>{
        this.toastr.error('Error while getting organization.', 'Error');
      }
    })
  }

  getProfile(pk:any){
    
    if(this.user){
      this.apiService.getProfiledetail(pk).pipe(takeUntil(this.destroy$)).subscribe({
        next: (res: any) => {
            this.profile = res
            this.profile.imageUrl = res.profile_pic ? res.profile_pic : 'logo/kyra-logo-no-bg.png';
            this.updateProfilePermissions(res.groups?.[0] || '');
            if (this.canEditRole && !Object.keys(this.role).length) {
              this.groups();
            }
            // let orgVal =  getValueByKey(this.organization, res.organization ) ?? '';
            // let roleVal =  getValueByKey(this.role, res.groups[0] ) ?? '';
            
            // this.profile.organization = orgVal
            this.profileForm = this.fb.group({
            userName: [res.username, Validators.required],
            role: [res.groups[0], Validators.required],
            firstName: [res.first_name, Validators.required],
            lastName: [res.last_name],
            email: [res.email, Validators.required],
            mobileNumber: [res.mobile_number, Validators.required],
            imageUrl: [res.profile_pic],
            organization: [res.organization, Validators.required],
          });

          this.profileForm.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
            this.checkFormChanges();
            this.mobileNumberChanges();
          });
        },
        error: (err) => {
          if (err['error']['non_field_errors']) {
            err['error']['non_field_errors'].forEach((element:any) => {
              this.toastr.error(element, 'Error');
            });
          }
        }
      })
    }else{
      this.toastr.error("Given userId is wrong", 'Error');
    }
  }

  // onFileSelected(event: Event) {
  //   const input = event.target as HTMLInputElement;
  //   if (input.files && input.files[0]) {
  //     this.selectedFile = input.files[0];
  //     // Update profileForm to preview the selected image
  //     const reader = new FileReader();
  //     reader.onload = () => {
  //       this.profile.imageUrl = reader.result as string;
  //     };
  //     reader.readAsDataURL(this.selectedFile);
  //   }
  // }

  // Update onFileSelected method
  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      const file = input.files[0];
      
      // Validate file type
      const allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
      if (!allowedTypes.includes(file.type)) {
        this.toastr.error('Please upload only image files (JPG, PNG, GIF, WEBP)', 'Invalid File');
        return;
      }

      // Validate file size (e.g., 5MB max)
      const maxSize = 5 * 1024 * 1024; // 5MB in bytes
      if (file.size > maxSize) {
        this.toastr.error('File size should be less than 5MB', 'File Too Large');
        return;
      }

      this.selectedFile = file;

      // Preview image
      const reader = new FileReader();
      reader.onload = () => {
        this.profile.imageUrl = reader.result as string;
      };
      reader.readAsDataURL(file);

      // Upload immediately
      this.uploadProfileImage(file);
    }
  }

  // Add new method for image upload
  uploadProfileImage(file: File) {
    const formData = new FormData();
    formData.append('profile_pic', file);

    this.apiService.updateProfile(this.profile.id, formData).subscribe({
      next: (res: any) => {
        this.toastr.success('Profile picture updated successfully', 'Success');
        this.profile.imageUrl = res.profile_pic;
      },
      error: (err) => {
        this.toastr.error(this.getBackendErrorMessage(err) || 'Failed to upload profile picture', 'Error');
        // Revert to previous image
        this.getProfile(this.profile.id);
      }
    });
  }

  private getBackendErrorMessage(err: any): string {
    const error = err?.error;
    if (!error) {
      return '';
    }
    if (typeof error.detail === 'string') {
      return error.detail;
    }
    if (Array.isArray(error.profile_pic) && error.profile_pic.length) {
      return error.profile_pic.join(' ');
    }
    return '';
  }
 

  saveProfile() {
    // const changedData = this.getChangedFields();
    // this.getChangedFields();
    if (this.profile && this.profileForm.valid){
      // let formData = new FormData();
      // formData.append('username', this.profileForm.value.userName)
      // formData.append('first_name', this.profileForm.value.firstName)
      // formData.append('last_name', this.profileForm.value.lastName)
      // formData.append('email', this.profileForm.value.email)
      // formData.append('mobile_number', this.profileForm.value.mobileNumber)
      // // formData.append('organization', '1')
      // if (this.selectedFile) {
      //   formData.append('profile_pic', this.selectedFile);
      // }
      // // let role =  getKeyByValue(this.role, this.profileForm.value.role) ?? '';
      // // formData.append('groups', role)
      // // let organization =  getKeyByValue(this.organization, this.profileForm.value.organization) ?? '';
      // // console.log(organization);
      
      // formData.append('organization', this.profileForm.value.organization)
      // formData.append('groups', JSON.stringify([this.profileForm.value.role]))

      let updatedFields = getUpdatedFieldsJsonReq(this.profileForm, this.fieldMapping);
            
      this.apiService.updateProfile(this.profile.id, updatedFields).subscribe({
        next: () => {
          this.toastr.success("Profile Updated successfully.", 'Success');
          this.redirect();
        },
        error: (err) => {
          if (err['error']['non_field_errors']) {
            err['error']['non_field_errors'].forEach((element:any) => {
              this.toastr.error(element, 'Error');
            });
          }else if (err['error']['mobile_number']) {
            err['error']['mobile_number'].forEach((element:any) => {
              this.toastr.error(element, 'Error');
            });
        }
      }
      });
    }else{
      validateAllFormFields(this.profileForm)
    }
  }


  // onCancel() {

  
  // this.redirect()
  // }
  onCancel() {

    if (this.route.snapshot.paramMap.get('pk')){
      this.router.navigate(['/organization'], { state: { activeTab: 'staff' } });

    }else {
      // Get the stored URL or default to dashboard
    const returnUrl = history.state?.returnUrl || '/dashboard';
    
    // Navigate with a small delay to ensure proper state update
    setTimeout(() => {
      this.router.navigate([returnUrl], {
        state: { refreshSidebar: true }  // Add a flag to trigger sidebar update
      });
    }, 0);
    }
    
  }

  redirect(){
    if (this.route.snapshot.paramMap.get('pk')){
      this.router.navigate(['/organization'], { state: { activeTab: 'staff' } });

    }else{
      // this.router.navigate(['/profile'])
      window.location.href = '/profile'
    }
  }
  checkFormChanges() {
    if (!this.profile) return;
    
    const formValue = this.profileForm.value;
    this.formChanged = 
      formValue.userName !== this.profile.username ||
      formValue.firstName !== this.profile.first_name ||
      formValue.lastName !== this.profile.last_name ||
      formValue.email !== this.profile.email ||
      formValue.mobileNumber !== this.profile.mobile_number ||
      (this.canEditRole && formValue.role !== (this.profile.groups?.[0] || '')) ||
      this.selectedFile !== null;
  }
  mobileNumberChanges(){

    const formValue = this.profileForm.value;
    this.mobileChanged = formValue.mobileNumber !== this.profile.mobile_number
    // if (this.mobileChanged){
    //   this.isMobileVerified = false;
    // }

  }

   startCountdown() {
    this.timer = 100;
    if (this.intervalId) clearInterval(this.intervalId);

    this.intervalId = setInterval(() => {
      if (this.timer > 0) {
        this.timer--;
      } else {
        clearInterval(this.intervalId);
      }
    }, 1000);
  }

  sendOTP() {
    const rawData = {
      mobile_number: this.profileForm.value.mobileNumber
    };

    this.apiService.sendMobileVerificationOTP(rawData).subscribe({
      next: (res) => {
        this.mobileNumber = res['mobile_number'];
        this.toastr.success('OTP sent successfully', 'Success')
        // Reset OTP input fields
        if (this.otpControls && Array.isArray(this.otpControls)) {
          this.otpControls.forEach(ctrl => ctrl.setValue(''));
        }

        this.otpForm.get('mobile_number')?.setValue(this.mobileNumber);
        this.showConfirmationDialog = true;

        this.startCountdown();
      },
      error: (err) => {
         this.toastr.error(err.error?.detail || 'Failed to send OTP', 'Error')

      },
    });
  }
   
  verifyOTP() {
  if (this.otpForm.invalid) {
   
    return;

  }
    

  this.isSubmitting = true;
  this.apiService.verifyMobileOTP(this.otpForm.value).subscribe({
    next: () => {
      this.authService.saveToLocalStorage();
        this.authService.updateStoredUser({is_mobile_verified: true});
        this.curUser = JSON.parse(localStorage.getItem('user') || '{}');
      this.toastr.success('OTP Verified successfully', 'Success')
      this.closeConfirmationDialog();
      this.isMobileVerified = true;
      // this.router.navigate(['/profile']);
      window.location.href = "/profile"

    },
    error: (err) => {
      this.toastr.error(err.error?.detail || 'Verification failed', 'Error')
      this.isSubmitting = false;
    }
  });
}
otpControls = Array.from({ length: 6 }, () => new FormControl(''));

onOtpInput(event: any, idx: number) {
  const input = event.target;
  const value = input.value;
  if (value.length === 1 && idx < this.otpControls.length - 1) {
    input.nextElementSibling?.focus();
  }
  this.updateOtpForm();
}

onOtpKeyDown(event: KeyboardEvent, idx: number) {
  const input = event.target as HTMLInputElement;
  if (event.key === 'Backspace' && !input.value && idx > 0) {
    (input.previousElementSibling as HTMLInputElement | null)?.focus();
  }
}

updateOtpForm() {
  const otp = this.otpControls.map(ctrl => ctrl.value).join('');
  this.otpForm.get('otp')?.setValue(otp);
}


// confirmVerify(){
//   this.verifyOTP();
// }

// Model for confirming deletion
  openConfirmationDialog(index: number) {
    this.showConfirmationDialog = true;
    // this.pId = index;
  }

  closeConfirmationDialog() {
    this.showConfirmationDialog = false;
  }

  // getChangedFields() {
  //   const updatedData: any = {};
  //   Object.keys(this.profileForm.controls).forEach((key) => {
  //     // const apiFieldName = this.fieldMapping[key];  // Get the API field name
  //     const currentValue = this.profileForm.get(key)?.value;
  //     const initialValue = this.profile[key];
      
  //     // if (currentValue !== initialValue && key !== "role" && key !== "userName") {
  //     //   updatedData[apiFieldName] = currentValue;
  //     // }
  //     console.log('keychange',key)
  //   });
  //   return updatedData;
  // }

  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    this.destroy$.next();
    this.destroy$.complete();
  }

  get displayRole(): string {
    return this.formatRoleLabel(this.profile?.groups?.[0] || '');
  }

  get editableRoleLabel(): string {
    return this.formatRoleLabel(this.profileForm?.get('role')?.value || this.profile?.groups?.[0] || '');
  }

  private updateProfilePermissions(targetRole: string): void {
    this.isLockedRoleProfile = this.isOwnProfile || targetRole === 'Superuser';
    this.canEditProfile = this.isOwnProfile || this.isSuperUserViewer || this.isAdminViewer;
    this.canEditRole = !this.isLockedRoleProfile
      && (
        this.isSuperUserViewer
        || (this.isAdminViewer && targetRole !== 'Sales Manager')
      );
  }

  private formatRoleLabel(role: string): string {
    return role === 'Superuser' ? 'Super User' : role;
  }

}
